import React, { Fragment } from "react";
import Navbar3 from "../../components/Navbar3/Navbar3";
import PageTitle from "../../components/pagetitle/PageTitle";
import Scrollbar from "../../components/scrollbar/scrollbar";
import IndustryChallenges from "../../components/IndustryChallenges/IndustryChallenges";
import ServiceCard from "../../components/ServiceCard/ServiceCard";
import CaseStudyCard from "../../components/CaseStudyCard/CaseStudyCard";
import SoftwareFeatures from "../../components/SoftwareFeatures/SoftwareFeatures";
import FeaturedBlogs from "../../components/FeaturedBlogs/FeaturedBlogs";
import RealEstateBusiness from "../../components/RealEstateBusiness/RealEstateBusiness";
import Footer from "../../components/footer/Footer";
import IconCard1 from "../../images/icon_card_20.png";
import IconCard2 from "../../images/icon_card_16.png";
import IconCard3 from "../../images/icon_card_17.png";
import IconCard4 from "../../images/icon_card_6.png";
import imageEcom from "../../images/img_ecom.png";

const ProjectPageS7 = () => {
  const solutions = [
    {
      title: "Struggling with Customer Acquisition & Retention?",
      problem: "High competition, complex onboarding.",
      solution:
        "We develop SEO-optimized finance portals, AI-driven customer support, and data-driven marketing to improve acquisition and retention.",
    },
    {
      title: "Need a Seamless & Secure Digital Banking Experience?",
      problem: "Outdated platforms, slow transactions, and security concerns.",
      solution:
        "We create user-friendly e-commerce platforms with seamless navigation and personalized recommendations.",
    },
    {
      title: "Compliance & Regulatory Challenges?",
      problem:
        "The Problem: Ever-changing regulations and cybersecurity threats.",
      solution:
        "We implement automated compliance tracking, fraud detection systems, and secure data encryption to meet regulatory standards.",
    },
  ];

  const services = [
    {
      title: "Web Development",
      description: [
        "Custom banking portals with intuitive UX/UI",
        "Secure payment gateways & online transaction solutions",
        "AI-powered chatbots for customer support",
        "Data analytics dashboards & fraud detection tools",
        "Mobile banking apps for seamless transactions",
      ],
      image: require("../../images/web-development-5.png"),
      background: "linear-gradient(to bottom, #A240BF, #FECDCDCC)",
    },
    {
      title: "Digital Marketing",
      description: [
        "SEO & content marketing to boost credibility",
        "PPC advertising for lead generation",
        "Email marketing & automation for customer engagement",
        "Social media marketing for brand trust & authority",
        "Reputation & online presence management",
      ],
      image: require("../../images/digital-marketing-5.png"),
      background: "linear-gradient(to bottom, #A240BF, #FECDCDCC)",
    },
  ];

  const features = [
    { title: "Modern banking UI/UX mockups", icon: IconCard1 },
    { title: "Financial analytics dashboards & reports", icon: IconCard2 },
    { title: "Secure transaction system infographics", icon: IconCard3 },
    { title: "AI-powered chatbot interface previews", icon: IconCard4 },
  ];

  const caseStudyData = {
    sectionTitle: "Success Stories in Finance & Banking",
    sectionSubtitle:
      "Our AI-powered finance portal increased customer sign-ups by 75% within 6 months!",
    image: require("../../images/cart/cart.png"),
    imageAlt: "E-commerce Case Study",
    title: "Establishment of an Ecom",
    description:
      "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum is simply dummy text of the printing and typesetting industry.",
    buttonText: "Read More",
    viewMoreText: "View More Case Studies ➜",
  };

  const realEstateData = {
    title: "Let’s Elevate Your Financial Services",
    description:
      "Drive Growth, Security & Innovation – Unlock New Opportunities in the Financial Sector",
    buttonText: "Schedule a Strategy Call Today",
    image: require("../../images/finance.png"),
  };

  const blogs = [
    {
      id: 1,
      title: "Establishment of an Ecom",
      description:
        "Lorem Ipsum is simply dummy text of the printing and typesetting industry.",
      image: imageEcom,
    },
    {
      id: 2,
      title: "We Setup a Mark to Identity",
      description:
        "Lorem Ipsum is simply dummy text of the printing and typesetting industry.",
      image: "/img/workshowcase/work-1.png",
    },
    {
      id: 3,
      title: "Digitalization",
      description:
        "Lorem Ipsum is simply dummy text of the printing and typesetting industry.",
      image: "/img/workshowcase/work.png",
    },
  ];

  const header =
    "Stay ahead of the latest trends in IT innovation, security, and digital transformation.";

  return (
    <Fragment>
      <div
        style={{
          backgroundImage: `url('/img/solutionbg.jpeg')`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundAttachment: "fixed",
          position: "relative",
        }}
      >
        <Navbar3 topbarNone={"wpo-header-style-6"} />
        <PageTitle
          pageTitle={
            "Transforming Financial Services with Cutting-Edge Digital Solutions"
          }
          pageSub={
            "Secure, scalable, and customer-centric digital solutions to enhance financial operations, compliance, and customer engagement."
          }
          backgroundImage={require("../../images/web-8.png")}
          buttonText={"Get a free consultation"}
        />
        <IndustryChallenges solutions={solutions} />
        <ServiceCard services={services} />
        {/* <CaseStudyCard caseStudy={caseStudyData} /> */}
        <SoftwareFeatures
          features={features}
          title={"Visualizing the Future of Finance"}
          subTiltle={"When you team up with us for web development, you get"}
        />
        {/* <FeaturedBlogs blogs={blogs} header={header} /> */}
        <RealEstateBusiness
          title={realEstateData.title}
          description={realEstateData.description}
          buttonText={realEstateData.buttonText}
          image={realEstateData.image}
          alignItems="flex-start"
          justifyContent="flex-start"
          textAlign="flex-start"
          boxAlign="flex-start"
          titleColor="#000"
          descriptionColor="#343434"
        />
      </div>
      <Footer />
      <Scrollbar />
    </Fragment>
  );
};
export default ProjectPageS7;
